import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelectionParams } from '../hooks/useSelectionParams'
import DiscoverSwitch from './DiscoverSwitch'

export default function EnableFlexSwitch({ enabled, setEnabled, isLoading }) {
  const { t } = useTranslation()
  const { talents: selectedTalentIds, careers: selectedCareerIds } =
    useSelectionParams()

  if (selectedTalentIds.length === 0 || selectedCareerIds.length === 0) {
    return null
  }

  return (
    <DiscoverSwitch
      label={t('discover.talent_match_section.enable_flex')}
      checked={enabled}
      onChange={setEnabled}
      isLoading={isLoading}
    />
  )
}

EnableFlexSwitch.propTypes = {
  enabled: PropTypes.bool.isRequired,
  setEnabled: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
}
